import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { filter, map, Observable, zip, tap } from 'rxjs';
import { ENV_CONFIG, EnvironmentConfig } from '../../environments/environment.model';
import { LookupValue } from '../models/lookup.model';
import { ODataResponse } from '../models/odata-response.model';
import { ProductSearchResult } from '../models/product-search-result.model';
import { ORing } from '../models';

@Injectable({ providedIn: 'root' })
export class SearchService {
  url: string;
  version: string;
  oringUrl: string;
  oringVersion: string;

  constructor(
    private http: HttpClient,
    @Inject(ENV_CONFIG) private config: EnvironmentConfig) {
    this.url = this.config.endpoints.baseApi.url;
    this.version = this.config.endpoints.baseApi.version;
    this.oringUrl = this.config.endpoints.oRingsApi.url;
    this.oringVersion = this.config.endpoints.oRingsApi.version;
  }

  getSearchResults(q: string): Observable<ProductSearchResult[]> {
    const queryWithoutWildcard = q.replace(/%/g, '').toLowerCase();
    let oringOdataQuery = '';

    const queryElements = queryWithoutWildcard.split(' ');
    
    queryElements.forEach(element => {
      oringOdataQuery += `(contains(tolower(PartNumber),'${element}')`
      oringOdataQuery += ` or contains(tolower(ProductName),'${element}')`
      oringOdataQuery += ` or contains(tolower(MaterialName),'${element}')`
      oringOdataQuery += ` or contains(tolower(SellableWH),'${element}')`
      oringOdataQuery += ` or contains(tolower(ProductFamily),'${element}')`
      oringOdataQuery += ` or contains(tolower(ClosureList),'${element}')`
      oringOdataQuery += ` or contains(tolower(ProductType),'${element}'))`
      oringOdataQuery += ' and '
    });

    oringOdataQuery = oringOdataQuery.substring(0, oringOdataQuery.length - 5);

    const baseQuery = this.http.get<ProductSearchResult[]>(`${this.url}api/${this.version}/ProductSearch?q=${q}`)
      .pipe(
        map(f => f.filter(res => res.productType !== 'Trap'))
      );
    const oringQuery = this.http.get<ORing[]>(`${this.oringUrl}api/${this.oringVersion}/ProductsFlat?$filter=(${oringOdataQuery})`)
      .pipe(
        map(l => l.map(v => ({
          productType: 'O-Ring',
          productID: parseInt(v.partNumber.replace(/\D/g, '')),
          partNumber: v.partNumber,
          description: v.productName ?? 'UNKNOWN',
          obsoletePartNumber: ''
        }) as ProductSearchResult))
      );

    return zip(baseQuery, oringQuery)
            .pipe(map(x => x[0].concat(x[1])), tap(console.log));
  }
}
